import Box from '@mui/material/Box'
import { useTheme } from '@mui/material/styles'
import Typography from '@mui/material/Typography'
import noop from 'lodash/noop'
import PropTypes from 'prop-types'
import React from 'react'

import ExceptionsOverlay from 'assets/exceptions/overlay/Exceptions.png'
import GPSOverlay from 'assets/exceptions/overlay/GPS.png'

const ExceptionCardTopOverlay = ({ isExceptionImageView = true, latitude, longitude, onClick = noop }) => {
  const theme = useTheme()
  // Coordinates render over both the photo and map views (product ask) whenever they exist.
  const showCoordinates = latitude != null && longitude != null
  return (
    <Box left={0} position="absolute" right={0} top={0} zIndex={theme.zIndex.modal}>
      {showCoordinates && (
        <Box px={1.5} py={0.75} sx={{ background: 'linear-gradient(rgba(0, 0, 0, 0.65), transparent)' }}>
          <Typography color="common.white" variant="caption">
            {`${latitude}, ${longitude}`}
          </Typography>
        </Box>
      )}
      <Box
        className="overlay"
        position="absolute"
        right={8}
        sx={{
          cursor: 'pointer',
          '&:before': {
            width: 56,
            height: 56,
            background: 'linear-gradient(359deg, rgba(0, 0, 0, 0.20) 17.45%, rgba(0, 0, 0, 0.00) 39.76%, rgba(0, 0, 0, 0.00) 99.58%)',
            borderRadius: 1,
            border: '1px solid',
            borderColor: 'common.white',
            content: '""',
            position: 'absolute',
          },
        }}
        top={showCoordinates ? 40 : 8}
        onClick={onClick}
      >
        <Box border="1px solid" borderColor="common.white" borderRadius={1} className="overlay" display="inline-flex">
          <img alt="overlay" src={isExceptionImageView ? GPSOverlay : ExceptionsOverlay} />
        </Box>
        <Typography
          className="overlay"
          color="common.white"
          fontSize={isExceptionImageView ? 12 : 9}
          fontWeight={400}
          mt={-3}
          position="relative"
          textAlign="center"
          width={58}
        >
          {isExceptionImageView ? 'GPS' : 'Exceptions'}
        </Typography>
      </Box>
    </Box>
  )
}

ExceptionCardTopOverlay.propTypes = {
  isExceptionImageView: PropTypes.bool,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  onClick: PropTypes.func,
}

export default ExceptionCardTopOverlay
